import React from 'react';
import { Icon } from '@hometap/htco-components';

import './AlertError.scss';

type AlertErrorProps = {
  error: React.ReactNode | string[] | string;
};

const AlertError = ({ error }: AlertErrorProps) => {
  if (!error) {
    return null;
  }

  let displayError = error;

  if (Array.isArray(error)) {
    displayError = (
      <div>
        {error.map((error, index) => (
          <div key={index}>{error}</div>
        ))}
      </div>
    );
  }

  return (
    <span className="AlertError">
      <div className="AlertErrorIcon">
        <Icon name="error" />
      </div>
      {displayError}
    </span>
  );
};

export default AlertError;
